import { useState } from 'react';
import {
	Modal,
	Button,
	FormControl,
	Tooltip,
	OverlayTrigger,
} from 'react-bootstrap';
import { useFormik } from 'formik';
import { BsQuestionCircle } from 'react-icons/bs';
import { addParticipantValidate } from '@/utils/validation';
import { useParams } from 'react-router-dom';
import { decrypt } from '@/utils/crypto';
import { constant, modal } from '@/utils/constant';
import { emitAddParticipant, emitAssignTeamParticipant } from '@/utils/socketHelpers';

function AddParticipants({
	hide,
	show,
	isAddParticipantAssign = false,
	teamId,
	socket
}) {
	const params = useParams();
	const [isDisabled, setIsDisabled] = useState(false);

	const formik = useFormik({
		initialValues: {
			firstName: '',
			lastName: '',
			private_note: '',
		},
		validationSchema: addParticipantValidate,
		onSubmit: async values => {
			setIsDisabled(true);
			const addParticipantsData = {
				session_id: Number(decrypt(params?.id)),
				first_name: values.firstName,
				last_name: values.lastName,
				private_note: values.private_note,
			};
			try {
				const data = await emitAddParticipant(socket, addParticipantsData);				
				if(data?.data?.length > 0){
					socket.emit('store-session-welcome-model-first-last-name',{
						session_id: Number(decrypt(params?.id)),
						id: data.data[0].id,
						first_name: values.firstName,
						last_name: values.lastName
					});
				}
				if (isAddParticipantAssign && data?.status) {
					hide();
					const newValue = {
						participant_id: data?.data[0]?.id,
						role_id: isAddParticipantAssign?.role_id?.id,
						team_id: teamId,
						session_id: isAddParticipantAssign?.session_id,
						current_status: 0,
						is_game_leave: false,
						is_help_call_for_facilitator: false,
					};

					try {
						await emitAssignTeamParticipant(socket, newValue);
						setIsDisabled(false);
					} catch (updateError) {}
				} else {
					setIsDisabled(false);
					hide();
				}
			} catch (error) {
				setIsDisabled(false);
			}
		},
	});

	return (
		<>
			<Modal
				show={show}
				onHide={hide}
				size='md'
				centered
			>
				<Modal.Header
					className='bg-secondary'
					closeButton
				>
					<Modal.Title>{modal?.addParticipantModalTitle}</Modal.Title>
				</Modal.Header>
				<Modal.Body className='py-10'>
					<form
						className='mx-auto form'
						onSubmit={formik.handleSubmit}
					>
						<div>
							<label
								className='form-label'
								htmlFor='firstName'
							>
								{constant?.firstName}
							</label>
							<FormControl
								value={formik.values.firstName}
								onChange={formik.handleChange}
								name='firstName'
								placeholder=''
							/>
							{formik.submitCount > 0 && formik.errors.firstName && (
								<div className='text-danger'>{formik.errors.firstName}</div>
							)}
						</div>
						<div className='mt-6'>
							<label
								className='form-label'
								htmlFor='lastName'
							>
								{constant?.lastName}
							</label>
							<FormControl
								value={formik.values.lastName}
								onChange={formik.handleChange}
								name='lastName'
								placeholder=''
							/>
							{formik.submitCount > 0 && formik.errors.lastName && (
								<div className='text-danger'>{formik.errors.lastName}</div>
							)}
						</div>
						<div className='mt-6'>
							<OverlayTrigger
								placement='bottom'
								overlay={
									<Tooltip
										id='button-tooltip-2'
										className='tooltip-light'
									>
										<p className='mb-2'>{modal?.privateNoteModelTooltip}</p>
									</Tooltip>
								}
							>
								{({ ref, ...triggerHandler }) => (
									<div
										{...triggerHandler}
										className='d-inline-flex align-items-center form-label'
									>
										<span className='me-2'>{modal?.privateNote}</span>
										<span
											ref={ref}
											className='lh-none'
										>
											<BsQuestionCircle />
										</span>
									</div>
								)}
							</OverlayTrigger>
							<FormControl
								name='private_note'
								type='text'
								value={formik.values.private_note}
								onChange={formik.handleChange}
							/>
							{formik.submitCount > 0 && formik.errors.private_note && (
								<div className='text-danger'>{formik.errors.private_note}</div>
							)}
						</div>
						<div className='px-2'>
							<Button
								variant='secondary'
								size='lg'
								className='w-full mt-lg-16 mt-10'
								type='submit'
								disabled={isDisabled}
							>
								{modal?.addParticipantButtonText}
							</Button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		</>
	);
}
export default AddParticipants;
